const GetAllNotificationReducer = (state = { type: 'LOADING_ALL_NOTIFICATION_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_ALL_NOTIFICATION_ACTION':
            return action
        case 'RESET_ALL_NOTIFICATION_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetSaveNotificationReducer = (state = { type: 'LOADING_SAVE_NOTIFICATION_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SAVE_NOTIFICATION_ACTION':
            return action
        case 'RESET_SAVE_NOTIFICATION_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


const GetDeleteNotificationReducer = (state = { type: 'LOADING_DELETE_NOTIFICATION_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_DELETE_NOTIFICATION_ACTION':
            return action
        case 'RESET_DELETE_NOTIFICATION_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


const GetPublishNotificationReducer = (state = { type: 'LOADING_PUBLISH_NOTIFICATION_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_PUBLISH_NOTIFICATION_ACTION':
            return action
        case 'RESET_PUBLISH_NOTIFICATION_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


export {
    GetAllNotificationReducer,
    GetSaveNotificationReducer,
    GetDeleteNotificationReducer,
    GetPublishNotificationReducer
}